module.exports = __webpack_public_path__ + "img/Candy Flavored.01b45657.jpg";